<template>



  <div class="bokark">


    <div class="grammatik" :key="componentKey">

        <!--h2 class="goth-grammatiktitel">Grammatikboken</h2-->

        <div class="spaltcontainer">




            <div class="suddighet0"></div>
            <div class="suddighet1"></div>
            <div class="suddighet2"></div>

            <div class="botten-suddighet2"></div>
            <div class="botten-suddighet1"></div>
            <div class="botten-suddighet0"></div>

            <router-link
            v-if="!(!slutpath || slutpath == '/undefined' || slutpath=='/grammatikboken')"
            class="tillOvning"  :to="'/ovningar'+slutpath">
                <i class="fa fa-edit" style="font-size:48px;"></i>
                <br>&nbsp;öva
            </router-link>

            <div class="vansterspalt">

                <div class="" v-for="(item) in this.$router.options.routes" :key="item.path">
                    <div class="" v-if="item.props && item.props.grambok && (item.props.synligVid <= steg)"
                    v-bind:style="[(item.path == '/ovningar'+slutpath) ? {'background-color':'#bbb'} : {'background-color':'inherit'}]"
                    >

                        <p v-on:click="patha(item.path)" class="smarubriker"
                        v-bind:style="[(item.props.svartVid > steg) ? {'color':'brown'} : {'color':'black'}]"

                        >
                                {{item.props.title}}
                        </p>

                    </div>
                    <div  v-if="item.rubrik && (item.synligVid <= steg)">
                        <p class="storre-smarubriker"><b>{{item.rubrik}}</b></p>
                    </div>
                </div>
                <br>
            </div>


            <div id="hogerspalt" class="hogerspalt">



                <div class="hogerspalt-inner">



                <div class="grammatikstart" v-if="!slutpath || slutpath == '/undefined' || slutpath == '/grammatikboken' || slutpath == '/' || slutpath == ''">
                    <h2 class="goth-grammatiktitel">Grammatikboken</h2>
                    <br><br><br><br>
                        <font-awesome-icon class="jattestor" icon="book"></font-awesome-icon>

                </div>



                <PresensAvSvagaVerb class="mjukframkomst bottenfyllning" v-if="slutpath ==='/presens-av-svaga-verb'"/>
                <PresensAvStarkaVerb v-if="slutpath === '/presens-av-starka-verb'" class="mjukframkomst bottenfyllning" />
                <PresensAvSein v-if="slutpath === '/presens-av-sein'" class="mjukframkomst bottenfyllning" />
                <PresensAvHaben v-if="slutpath === '/presens-av-haben'" class="mjukframkomst bottenfyllning" />

                <PerfektAvSvagaVerb v-if="slutpath === '/perfekt-svaga-verb'" class="mjukframkomst bottenfyllning" />
                <PerfektAvStarkaVerb v-if="slutpath === '/perfekt-starka-verb'" class="mjukframkomst bottenfyllning" />
                <PerfektMedSeinSomHjalpverb v-if="slutpath === '/perfekt-med-sein-som-hjalpverb'" class="mjukframkomst bottenfyllning" />

                <ModalaHjalpverb v-if="slutpath === '/modala-hjalpverb'" class="mjukframkomst bottenfyllning" />
                <InfinitivPerfekt v-if="slutpath === '/infinitiv-vs-perfektparticip'" class="mjukframkomst bottenfyllning" />

                <ImperfektAvSvagaVerb v-if="slutpath === '/imperfekt-av-svaga-verb'" class="mjukframkomst bottenfyllning" />
                <ImperfektAvStarkaVerb v-if="slutpath === '/imperfekt-av-starka-verb'" class="mjukframkomst bottenfyllning" />

                <DerOrd v-if="slutpath === '/der-ord'" class="mjukframkomst bottenfyllning" />
                <DasOrd v-if="slutpath === '/das-ord'" class="mjukframkomst bottenfyllning" />
                <DieOrd v-if="slutpath === '/die-ord'" class="mjukframkomst bottenfyllning" />
                <GenusOchPlural v-if="slutpath === '/genus-och-plural'" class="mjukframkomst bottenfyllning" />

                <Adjektiv v-if="slutpath === '/adjektiv-stark-svag-bojning'" class="mjukframkomst bottenfyllning" />
                <AdjektivKomparation v-if="slutpath === '/adjektiv-komparation'" class="mjukframkomst bottenfyllning" />
                <SehrVielViele v-if="slutpath === '/sehr-viel-viele'" class="mjukframkomst bottenfyllning" />

                <Klockan v-if="slutpath === '/klockan'" class="mjukframkomst bottenfyllning" />
                <Nar v-if="slutpath === '/nar'" class="mjukframkomst bottenfyllning" />
                <HurOfta v-if="slutpath === '/hur-ofta'" class="mjukframkomst bottenfyllning" />


                <PrepositionerSomStyrAckusativ v-if="slutpath === '/prepositioner-som-styr-ackusativ'" class="mjukframkomst bottenfyllning" />
                <PrepositionerSomStyrDativ v-if="slutpath === '/prepositioner-som-styr-dativ'" class="mjukframkomst bottenfyllning" />
                <PrepositionerSomStyrAckusativEllerDativ v-if="slutpath === '/prepositioner-som-styr-ackusativ-eller-dativ'" class="mjukframkomst bottenfyllning" />
                <PrepositionerSpeciellaVerbuttryck v-if="slutpath === '/prepositioner-speciella-verbuttryck'" class="mjukframkomst bottenfyllning" />
                <Pronominaladverb v-if="slutpath === '/pronominaladverb'" class="mjukframkomst bottenfyllning" />


                <PossessivaPronomen v-if="slutpath === '/possessiva-pronomen'" class="mjukframkomst bottenfyllning" />
                <RelativaPronomenNominativ v-if="slutpath === '/relativa-pronomen-nominativ' || slutpath === '/relativa-pronomen-alla-kasus'" class="mjukframkomst bottenfyllning" />
                <RelativaPronomen v-if="slutpath === '/relativa-pronomen-alla-kasus'" class="mjukframkomst bottenfyllning" />


                <AlsWannWenn v-if="slutpath === '/als-wann-wenn'" class="mjukframkomst bottenfyllning" />
                <ObWenn v-if="slutpath === '/ob-wenn'" class="mjukframkomst bottenfyllning" />
                <DarforDarforAtt v-if="slutpath === '/darfor-darfor-att-for-att'" class="mjukframkomst bottenfyllning" />
                <Subjunktioner v-if="slutpath === '/subjunktioner'" class="mjukframkomst bottenfyllning" />

                <Ackusativobjekt v-if="slutpath === '/ackusativobjekt'" class="mjukframkomst bottenfyllning" />
                <AckusativOchDativobjekt v-if="slutpath === '/ackusativ-och-dativobjekt'" class="mjukframkomst bottenfyllning" />
                <VerbSomStyrDativ v-if="slutpath === '/verb-som-styr-dativ'" class="mjukframkomst bottenfyllning" />
                <Genitiv v-if="slutpath === '/genitiv'" class="mjukframkomst bottenfyllning" />


            </div>
        </div>
        </div>



</div>

</div>
</template>

<script>



import PresensAvSvagaVerb from './grammatik/presens-av-svaga-verb.vue'
import Adjektiv from './grammatik/adjektiv-stark-svag-bojning.vue'
import PresensAvSein from './grammatik/presens-av-sein.vue'
import PresensAvHaben from './grammatik/presens-av-haben.vue'
import Ackusativobjekt from './grammatik/ackusativobjekt.vue'
import AckusativOchDativobjekt from './grammatik/ackusativ-och-dativobjekt.vue'
import Genitiv from './grammatik/genitiv.vue'
import AdjektivKomparation from './grammatik/adjektiv-komparation.vue'

import SehrVielViele from './grammatik/sehr-viel-viele.vue'

import Klockan from './grammatik/klockan.vue'
import Nar from './grammatik/nar.vue'
import HurOfta from './grammatik/hur-ofta.vue'

import PerfektAvSvagaVerb from './grammatik/perfekt-svaga-verb.vue'
import PerfektAvStarkaVerb from './grammatik/perfekt-starka-verb.vue'
import PerfektMedSeinSomHjalpverb from './grammatik/perfekt-sein-som-hjalpverb.vue'
import PresensAvStarkaVerb from './grammatik/presens-av-starka-verb.vue'
import ImperfektAvSvagaVerb from './grammatik/imperfekt-av-svaga-verb.vue'
import ImperfektAvStarkaVerb from './grammatik/imperfekt-av-starka-verb.vue'
import ModalaHjalpverb from './grammatik/modala-hjalpverb.vue'
import InfinitivPerfekt from './grammatik/infinitiv-vs-perfekt.vue'

import DerOrd from './grammatik/der-ord.vue'
import DasOrd from './grammatik/das-ord.vue'
import DieOrd from './grammatik/die-ord.vue'
import GenusOchPlural from './grammatik/genus-och-plural.vue'



import PrepositionerSomStyrAckusativ from './grammatik/prepositioner-som-styr-ackusativ.vue'
import PrepositionerSomStyrDativ from './grammatik/prepositioner-som-styr-dativ.vue'
import PrepositionerSomStyrAckusativEllerDativ from './grammatik/prepositioner-som-styr-ackusativ-eller-dativ.vue'
import PrepositionerSpeciellaVerbuttryck from './grammatik/prepositioner-speciella-verbuttryck.vue'
import Pronominaladverb from './grammatik/pronominaladverb.vue'



import AlsWannWenn from './grammatik/als-wann-wenn.vue'
import ObWenn from './grammatik/ob-wenn.vue'
import DarforDarforAtt from './grammatik/darfor-darfor-att-for-att.vue'
import Subjunktioner from './grammatik/subjunktioner.vue'
import VerbSomStyrDativ from './grammatik/verb-som-styr-dativ.vue'

import PossessivaPronomen from './grammatik/possessiva-pronomen.vue'
import RelativaPronomenNominativ from './grammatik/relativa-pronomen-nominativ.vue'
import RelativaPronomen from './grammatik/relativa-pronomen.vue'

export default {
  name: 'Ovningsblad',
  title () {
    return `${this.aktuellTitel} | Grammatikboken`

  },
  components: {
    PresensAvSvagaVerb,
    Adjektiv,
    PresensAvSein,
    PresensAvHaben,
    Ackusativobjekt,
    AckusativOchDativobjekt,
    Genitiv,
    AdjektivKomparation,
    PerfektAvSvagaVerb,
    PerfektAvStarkaVerb,
    PerfektMedSeinSomHjalpverb,
    PresensAvStarkaVerb,
    AlsWannWenn,
    ImperfektAvSvagaVerb,
    ImperfektAvStarkaVerb,
    ObWenn,
    Subjunktioner,
    VerbSomStyrDativ,
    PrepositionerSomStyrAckusativ,
    PrepositionerSomStyrDativ,
    PrepositionerSomStyrAckusativEllerDativ,
    RelativaPronomen,
    RelativaPronomenNominativ,
    PrepositionerSpeciellaVerbuttryck,
    Pronominaladverb,
    ModalaHjalpverb,
    PossessivaPronomen,
    DarforDarforAtt,
    SehrVielViele,
    InfinitivPerfekt,
    DerOrd,
    DasOrd,
    DieOrd,
    GenusOchPlural,
    Klockan,
    Nar,
    HurOfta


},



  props: {
    title: String,
    uppgifter: Array,
    grammatik: String,
    avsnitt: String

},
data() {
        return {
            steg: 0,
            slutpath:"",
            componentKey: 0,
            redanAndelse:false,
            aktuellTitel:"Tysk grammatik",
            aktuellMeta: "Sune"

        }
},
watch: {
    $route (to){
        this.slutpath="/"+to.params.id;
        this.redanAndelse= true;
        window.document.getElementById('hogerspalt').scrollTop=0;
    }
},

methods: {
    vilkenSynlig: function() {
        var kk = window.document.done["Steg"];
        if (kk == "") {
            kk=6;
        }
        this.steg=kk;
    },
    patha: function(pathen) {
        var skaladPath = pathen.substring(pathen.lastIndexOf('/') + 1);
        this.$router.replace("/grammatikboken/"+skaladPath);
        this.vilkenTitel();

    },
    vilkenTitel: function() {
        setTimeout(function(){
            var titeln = document.getElementsByTagName("h2");
            var utsugenTitel = titeln[0].innerHTML;
            document.title = utsugenTitel + " | Grammatikboken";
            this.aktuellMeta = utsugenTitel;
        }, 100);
    }
},


updated() {
    this.vilkenSynlig();
},


mounted() {

    setTimeout(function(){
        window.scrollTo({
            //top: 230,
            //top: 68,
            top:0,
            left: 0,
            behavior: 'smooth'
            });
        }, 500);
        this.$root.$on('myEvent', (text) => { // here you need to use the arrow function
         this.message = text;
         this.vilkenSynlig();

        })
        this.vilkenSynlig();

        this.vilkenTitel();
        this.slutpath=("/" + (window.location.href.substring(window.location.href.lastIndexOf('/') + 1)));


    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.grammatik {
    padding-top:0px;
    width: calc(100vw - 463px);
    margin: auto;
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    -webkit-animation: mymove 1s; /* Safari 4.0 - 8.0 */
    animation: mymove 1s;
    margin-bottom: 1em;
    /*margin-top: 68px;*/

}

.bokark {
    margin-top: -43px;

    -webkit-animation: mjukframkomst 1s; /* Safari 4.0 - 8.0 */
    animation: mjukframkomst 1s;

}
/* Safari 4.0 - 8.0 */
@-webkit-keyframes mjukframkomst {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}

/* Standard syntax */
@keyframes mjukframkomst {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}













@media (max-width:1024px) {
    .grammatik {
        width: 100%;
    }
    .bokark {
        margin-top: -45px;
    }
}

/* Safari 4.0 - 8.0 */
/*

@-webkit-keyframes mymove {
  from {
      margin-top: 800px;
  }
  to {
      margin-top:0px;
  }
}
*/
/* Standard syntax */
/*
@keyframes mymove {
    from {
        margin-top: 800px;
    }
    to {
        margin-top:0px;
    }
}
*/
.vansterspalt {
    width: 25%;
    margin-left: 0;

    height: 90vh;
    background-image: url(../assets/textured_paper.png);
    background-repeat:repeat;

    overflow-y: auto;
}

.hogerspalt {
    width: 75%;
    right:0;
    /*top:79px;*/
    top:0;
    position: absolute;
    overflow-y: auto;
    height: 90vh;



}

.hogerspalt-inner {
    min-height: 100%;
    padding: 20px;
    padding-top: 0;
    padding-bottom:0px;

    background-image: url(../assets/textured_paper.png);
    background-repeat:repeat;
}

.spaltcontainer {
    display: inline;
    margin-top: 68px;
}

p.smarubriker{
    font-size: 0.8em;
    text-align: left;
    padding-left: 12px;
    margin:0;
    padding: 3px 0 3px 12px;
    border-bottom: 1px solid black;
    border-top: 1px solid black;
    margin-top:-1px;
}

p.smarubriker:hover{
    background-color: #bbb;
    cursor: pointer;
}


p.storre-smarubriker{
    font-size: 1.5em;
    text-align: left;
    padding-left: 12px;
    line-height: normal;
}


.stangd {
    max-height: 60px;

}



.goth-grammatiktitel {
    padding-top: 10px;
    font: 60px 'CloisterBlackLight', Arial, sans-serif;letter-spacing: 0;
    margin-bottom: 0;
    margin-top: 0;
}



h3 {
    font-family: sans-serif;
    margin-top: 0 !important;
}


@media (max-width:570px) {
    .goth-grammatiktitel {
        font-size: 2em;
    }
    h2 {
        font-size: 1em;
    }


    p.storre-smarubriker{
        font-size: 1em;
        text-align: left;
        padding-left: 12px;
        line-height: normal;
    }




}

.osynlig {
    display: none;
}

.rod {
    color: brown;
}

.svart {

    color: black;
}

.vansterspalt::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
}

.vansterspalt::-webkit-scrollbar-thumb {
    background-color: #555;
}
.vansterspalt::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    /*background-color: #F5F5F5;*/
    /*background-color: #caa88e;*/
    background-color: #999;
}


.hogerspalt::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
}

.hogerspalt::-webkit-scrollbar-thumb {
    background-color: #555;
}
.hogerspalt::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    /*background-color: #F5F5F5;*/
    /*background-color: #caa88e;*/
    background-color: #999;
}

.jattestor {
    font-size: 10em;
}

.suddighet0 {
    position: absolute;
    top:0;
    width: calc(75% - 16px);
    height: 2px;
    right:16px;
    background-color: #ddd;
    z-index:100;
    opacity: 0.8;
}


.suddighet1 {
    position: absolute;
    top:2;
    width: calc(75% - 16px);
    height: 9px;
    right:16px;
    background-color: #ddd;
    z-index:100;
    opacity: 0.6;
}

.suddighet2 {
    position: absolute;
    top:9px;
    right:16px;
    width: calc(75% - 16px);
    height: 9px;
    background-color: #ddd;
    z-index:100;
    opacity: 0.3;
}




.botten-suddighet2 {
    position: absolute;
    bottom:9px;
    right:16px;
    width: calc(75% - 16px);
    height: 9px;
    background-color: #ddd;
    z-index:100;
    opacity: 0.3;
}

.botten-suddighet1 {
    position: absolute;
    bottom:2px;
    width: calc(75% - 16px);
    height: 9px;
    right:16px;
    background-color: #ddd;
    z-index:100;
    opacity: 0.6;
}


.botten-suddighet0 {
    position: absolute;
    bottom: 0;
    width: calc(75% - 16px);
    height: 2px;
    right:16px;
    background-color: #ddd;
    z-index:100;
    opacity: 0.8;
}

.tillOvning {
    position: absolute;
    bottom: 45px;
    right: 35px;
    z-index:100;
    opacity: 0.5;
    text-decoration: none;
    color:inherit;
    text-align: left;
}

.tillOvning:hover {
    color: black;
    opacity: 1;
}


.mjukframkomst {
    -webkit-animation: mjukfram 0.5s; /* Safari 4.0 - 8.0 */
    animation: mjukfram 0.5s;
}

.bottenfyllning {
  padding-bottom:20px;
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes mjukfram {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}

/* Standard syntax */
@keyframes mjukfram {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

/*.bokark {
    margin-top:68px;

}*/

.grammatikstart{
  overflow-y: hidden;
}

</style>
